export const USER_LIST = '/api/user/v1/list';
export const USER_INVITE = '/api/v1/invitation/invite-users';
export const CHECK_INVITED_EMAIL = '/api/v1/invitation/check-invited-emails';
export const USER_REMOVE = '/api/user/v1/remove-users';
export const MAKE_ADMIN = '/api/user/v1/make-admin';
export const REMOVE_ADMIN = '/api/user/v1/remove-admin';
